import { type InsuranceCorporateIdentity } from "../types";

export function BKKExklusivLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_30_516)">
        <mask
          id="mask0_30_516"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="62"
          y="185"
          width="399"
          height="142"
        >
          <path d="M62.9995 327H461V185H62.9995V327Z" fill="white" />
        </mask>
        <g mask="url(#mask0_30_516)">
          <path
            d="M100.465 299.037H111.543C125.242 299.037 139.542 297.023 139.542 282.716C139.542 267.405 124.839 265.995 111.946 265.995H100.465V299.037ZM100.465 240.609H110.939C123.226 240.609 135.916 237.586 135.916 225.699C135.916 212.804 123.832 211.595 111.342 211.595H100.465V240.609ZM63 184.999H127.658C153.843 184.999 173.381 196.484 173.381 220.662C173.381 238.393 164.317 248.264 148.607 253.504V253.907C167.339 257.734 177.007 267.808 177.007 284.933C177.007 318.581 147.397 325.632 122.22 325.632H63V184.999Z"
            fill="#C1CCEA"
          />
          <path
            d="M180.033 185H217.497V242.421H217.901L260.198 185H305.315L253.35 250.481L309.344 325.632H261.608L217.901 261.762H217.497V325.632H180.033V185Z"
            fill="#C1CCEA"
          />
          <path
            d="M307.134 185H344.599V242.421H345.002L387.3 185H432.419L380.451 250.481L436.446 325.632H388.71L345.002 261.762H344.599V325.632H307.134V185Z"
            fill="#C1CCEA"
          />
          <path
            d="M209.146 294.079C209.146 284.409 205.235 274.848 195.026 274.848C184.922 274.848 178.732 284.952 178.732 294.079H209.146ZM212.511 323.956C207.734 325.912 201.544 326.999 196.438 326.999C178.079 326.999 171.238 314.615 171.238 297.989C171.238 281.042 180.578 268.979 194.59 268.979C210.233 268.979 216.64 281.586 216.64 296.469V299.945H178.732C178.732 311.68 185.032 321.133 196.981 321.133C201.977 321.133 209.253 319.069 212.511 317.002V323.956Z"
            fill="white"
          />
          <path
            d="M234.774 296.359L217.179 270.283H225.65L238.793 290.927L252.154 270.283H259.972L242.812 296.359L261.82 325.695H253.346L238.793 301.795L223.261 325.695H215.331L234.774 296.359Z"
            fill="white"
          />
          <path
            d="M262.252 244.207H269.095V292.991L293.86 270.283H302.659L275.611 294.84L305.914 325.695H296.467L269.095 297.229V325.695H262.252V244.207Z"
            fill="white"
          />
          <path
            d="M307.542 244.207H314.386V325.695H307.542V244.207Z"
            fill="white"
          />
          <path
            d="M365.867 312.658C365.867 316.896 365.867 321.241 366.297 325.695H359.674V315.809H359.456C357.178 320.808 353.046 327 341.535 327C327.848 327 322.635 317.873 322.635 305.705V270.283H329.478V303.964C329.478 314.396 333.169 321.134 342.622 321.134C355.112 321.134 359.026 310.158 359.026 300.923V270.283H365.867V312.658Z"
            fill="white"
          />
          <path
            d="M369.772 317.655C373.899 319.719 378.897 321.134 384.218 321.134C390.733 321.134 396.492 317.547 396.492 311.245C396.492 298.098 369.88 300.164 369.88 284.082C369.88 273.108 378.786 268.978 387.911 268.978C390.843 268.978 396.71 269.632 401.598 271.478L400.947 277.454C397.361 275.824 392.473 274.849 388.672 274.849C381.613 274.849 376.723 277.021 376.723 284.082C376.723 294.406 403.987 293.101 403.987 311.245C403.987 322.98 393.017 327 384.653 327C379.33 327 374.009 326.346 369.118 324.39L369.772 317.655Z"
            fill="white"
          />
          <path
            d="M407.242 270.283H414.085V325.695H407.242V270.283ZM414.088 255.508H407.244V246.381H414.088V255.508Z"
            fill="white"
          />
          <path
            d="M441.562 325.696H433.524L414.731 270.284H422.228L437.543 318.199H437.761L453.834 270.284H461.005L441.562 325.696Z"
            fill="white"
          />
          <path
            d="M420.253 244.906C422.474 250.256 419.935 256.402 414.581 258.621C409.235 260.841 403.093 258.301 400.872 252.951C398.651 247.598 401.192 241.454 406.538 239.232C411.892 237.016 418.037 239.555 420.253 244.906Z"
            fill="#76B82A"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_30_516">
          <rect
            width="398"
            height="142"
            fill="white"
            transform="translate(63 185)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export const BKKExklusiv: InsuranceCorporateIdentity = {
  id: "bkk-exklusiv",
  name: "BKK exklusiv",
  logo: BKKExklusivLogo,
  backgroundColor: "#005DA9",
  textColor: "#FFFFFF",
  wildcard: "bkk exklusiv",
  type: "statutory",
};
